"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Child = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const DocumentImageOffMIcon_1 = require("@alfalab/icons-glyph/DocumentImageOffMIcon");
const text_1 = require("./text");
const index_module_css_1 = __importDefault(require("./index.module.css"));
const Child = ({ children, hasImage, imageLoadingFailed, text, colorText, size }) => {
    if (hasImage)
        return null;
    if (imageLoadingFailed) {
        if (text) {
            return (0, jsx_runtime_1.jsx)(text_1.Text, { text: text, componentSize: size, colorText: colorText });
        }
        return ((0, jsx_runtime_1.jsx)(DocumentImageOffMIcon_1.DocumentImageOffMIcon, { className: index_module_css_1.default.iconErrorColor, "data-test-id": 'Image error' }));
    }
    if (text) {
        return (0, jsx_runtime_1.jsx)(text_1.Text, { text: text, componentSize: size, colorText: colorText });
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: children });
};
exports.Child = Child;
